// extracted by mini-css-extract-plugin
export default {"emote":"_3Y0Hp","not-official":"B86MN","notOfficial":"B86MN","title":"_3pP1T","emote-pixel":"_1S-yl","emotePixel":"_1S-yl"};